import abi from './abi.json'
import deploy from './deploy.json'
import Istore from '@/store'
import {block, isStrEmpty} from "@/common";

let TokenInfo = null

const methods = {

    init(contractAddress) {
        console.log('usdt contract init')
        for (let i = 0; i < deploy.length; i++) {
            if (deploy[i].address === contractAddress) {
                TokenInfo = deploy[i]
            }
        }

        if (!TokenInfo) {
            console.log('invalid address ', contractAddress)
            return null
        } else {

            if (isStrEmpty(window.web3js)) {
                block.initWeb3()
            }

            window.UsdtAbi = new window.web3js.eth.Contract(abi, contractAddress)
            // 外部对象
            return window.UsdtAbi
        }
    },

    balanceOf(fromAccount) {
        return new Promise((resolve) => {
            window.UsdtAbi.methods.balanceOf(fromAccount).call()
                .then(function (response) {
                    console.log('usdt balance',fromAccount, response)
                    //如果是当前钱包账号 则更新余额
                    if (fromAccount === Istore.state.wallet.account) {
                        Istore.state.wallet.balance.usdt = response.toString()
                    }

                    resolve(response.toString())
                })
                .catch(function (error) {
                    console.log('usdt balanceOf error', fromAccount, error)
                    Istore.state.wallet.balance.usdt = 0
                    resolve('0')
                })
        })
    },

    symbol() {
        console.log('usdt symbol')
        return new Promise(resolve => {
            window.UsdtAbi.methods.symbol().call()
                .then(function (response) {
                    resolve(response.toString())
                })
                .catch(error => {
                    console.log('symbol error', error)
                    resolve('')
                })
        })
    },

    totalSupply() {
        return new Promise(resolve => {
            window.UsdtAbi.methods.totalSupply().call()
                .then(function (response) {
                    resolve(response.toString())
                })
                .catch(error => {
                    console.log('totalSupply error', error)
                    resolve('')
                })
        })
    },

    // 获取合约静态属性
    async getStaticData() {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return null
        }
        const makerProperty = {}

        makerProperty.symbol = await this.symbol()
        makerProperty.totalSupply = await this.totalSupply()

        return makerProperty

    },

    // 获取合约动态属性
    async getDynamicData() {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return null
        }
        const makerProperty = {}

        //........

        return makerProperty

    },

    transfer(from, to, value) {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return false
        }
        console.log('transfer usdt', from, to, value)
        return new Promise((resolve) => {
            window.UsdtAbi.methods.transfer(to, value)
                .send({from: from})
                .then(function(receipt){
                    console.log('usdt transfer receipt', receipt)
                    resolve(true)
                })
                .catch(error=>{
                    console.log('usdt transfer error', error)
                    resolve(false)
                })
        })
    },

    /**
     * @desc  从当前from账号转出
     * @param from 代币持有者
     * @param key 签名账号key
     * @param to 要转到对象地址
     * @param value 发送值(wei)
     * @return Promise bool
     * */
    async transferSign(from, key, to, value) {

        if (window.UsdtAbi === null) {
            this.init(Istore.state.chain.USDT)
            console.log('invalid contract object')
        }
        // 检查水龙头余额
        const balance = await this.balanceOf(from)
        if (BigInt(balance)< BigInt(value)) {
            console.log('Account balance is insufficient')
            return 'Account balance is insufficient'
        }
        console.log('transferSign', from, to, value, TokenInfo)
        return new Promise((resolve) => {
            let rawTx = {
                from: from,
                to: TokenInfo.address,
                gas: Istore.state.gasDef.middle,
                data: window.UsdtAbi.methods.transfer(to, value).encodeABI()
            }

            // 用Key签名解锁账号
            window.web3js.eth.accounts.signTransaction(rawTx, key)
                .then((signedTx) => {
                    window.web3js.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction )
                        .on("receipt", receipt => {
                            console.log('usdt transferSign receipt', receipt)
                            resolve('succeed')
                        })
                        .on('error', (err) => {
                            console.log('usdt transferSign error', err)
                            resolve('usdt transferSign error')
                        })

                })
                .catch(error => {
                    console.log('usdt signTransaction error', error)
                    resolve('usdt signTransaction error')
                })
        })
    },

    // 签名交易返回字符串hash
    transferSignHash(from, key, to, value) {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return ''
        }
        console.log('transferSign', to, value, TokenInfo.address)
        return new Promise((resolve) => {
            let rawTx = {
                from: from,
                to: TokenInfo.address,
                gas: Istore.state.gasDef.low,
                data: window.UsdtAbi.methods.transfer(to, value).encodeABI()
            }

            // 用Key签名解锁账号
            window.web3js.eth.accounts.signTransaction(rawTx, key)
                .then((signedTx) => {
                    window.web3js.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction)
                        .on("receipt", receipt => {
                            console.log('usdt transferSign receipt', receipt)
                            resolve(receipt)
                        })
                        .on('error', (err) => {
                            console.log('usdt transferSign error', err)
                            resolve('')
                        })

                })
                .catch(error => {
                    console.log('usdt signTransaction error', error)
                    resolve('')
                })
        })
    },

    // 从from转账到to
    // 需先批准
    transferFrom(GasFrom, from, to, value) {
        console.log('transferFrom', GasFrom, from, to, value)
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return false
        }
        return new Promise((resolve) => {
            window.UsdtAbi.methods.transferFrom(from, to, value)
                .send({from: GasFrom, gas: Istore.state.gasDef.low})
                .on("receipt", receipt => {
                    console.log('usdt transferFrom receipt', receipt)
                    resolve(true)
                })
                .on('error', (err) => {
                    resolve(false)
                    console.log('usdt transferFrom error', err)
                })
        })
    },

    approveSign(from, key, spender, value) {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return false
        }

        return new Promise((resolve) => {
            let rawTx = {
                from: from,
                to: TokenInfo.address,
                gasLimit: Istore.state.gasDef.middle,
                data: window.UsdtAbi.methods.approve(spender, value).encodeABI()
            }

            // 用Key签名解锁账号
            window.web3js.eth.accounts.signTransaction(rawTx, key)
                .then((signedTx) => {
                    window.web3js.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction)
                        .on("receipt", receipt => {
                            console.log('usdt approveSign receipt', value, receipt)
                            resolve(true)
                        })
                        .on('error', (err) => {
                            console.log('usdt approveSign error', err)
                            resolve(false)
                        })

                })
                .catch(error => {
                    console.log('usdt approveSign error', error)
                    resolve(false)
                })
        })
    },

    /**
     * @desc  仅批准当前交易值 批准数量不会叠加 可用approve 0将原有的allowance清0
     * @param fromAccount 代币持有者
     * @param spender 为要批准的对象地址
     * @param value 批准值(wei)
     * @return Promise bool
     * */
    approve(fromAccount, spender, value) {
        if (window.UsdtAbi === null) {
            console.log('invalid contract object')
            return false
        }
        console.log('usdt approve', fromAccount, spender, value)
        return new Promise((resolve) => {
            window.UsdtAbi.methods.approve(spender, value)
                .send({from: fromAccount})
                .then(receipt => {
                    console.log('usdt approve receipt', receipt)
                    resolve(true)
                })
                .catch((err) => {
                    console.log('usdt approve error', err)
                    resolve(false)
                })
        })
    },

    allowance(owner, spender) {

        return new Promise((resolve) => {
            window.UsdtAbi.methods.allowance(owner.toString(), spender.toString())
                .call({from: Istore.state.wallet.account})
                .then(function (response) {
                    resolve(response.toString())
                })
                .catch(error => {
                    console.log('usdt allowance error', error)
                    resolve(false)
                })
        })
    }
}

export default {methods}
